module.exports = __webpack_public_path__ + "img/icon-prerolls.6e2e72e8.svg";